export {
  connectAuthEmulator,
  getAuth as default,
  getIdTokenResult,
  isSignInWithEmailLink,
  signInWithEmailLink,
} from 'firebase/auth';
